<template>
  <div :class="'vuetimepicker ' + (clearable ? ' clearable' : '') + (time ? ' has-value' : '')">
    <label :for="labelId" :class="'product-order-datetitle title'" v-if="title">{{ title }}</label>
    <VueDatePicker 
        v-model="time" 
        ref="picker"
        :time-picker="true"
        :time-config="{ 
          minutesIncrement: currentMinutesIncrement, 
          minutesGridIncrement: minutesIncrement === 15 ? 15 : 5 }"
        :formats="{ input: timeFormat, preview: timeFormat }" 
        :placeholder="placeholder" 
        :timezone="timezone" 
        :teleport="true" 
        :input-attrs="{
          hideInputIcon: true,
          clearable: clearable,
        }"
        :ui="datePickerClasses"
        :enable-minutes="disableMinutes ? false : true"
        :text-input="{
          selectOnFocus: true,
        }"
    >
      <template #action-row="{ selectDate, closePicker }">
        <div class="dp-action-row">
          <button type="button" class="btn btn-sm btn-default" @click="closePicker">{{ _('Cancel') }}</button>
          <button type="button" class="btn btn-sm btn-success" @click="selectDate">{{ _('Select') }}</button>
        </div>
      </template>
    </VueDatePicker>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  data () {
    return {
      picker: null,
      identifier: '',
    }
  },
  props: ['modelValue', 'format', 'title', 'placeholder', 'shortLocale', 'value', 'disableMinutes', 'clearable', 'tz', 'minutesIncrement'],
  emits: ['update:modelValue'],
  computed: {
    ...mapGetters(['allSettings', 'shopId', 'locale']),
    currentMinutesIncrement () {
      if (!this.time || !this.minutesIncrement) {
        return 1
      }
      if (this.time.minutes % this.minutesIncrement === 0) {
        return this.minutesIncrement
      }
      return 1
    },
    timezone () {
      return this.tz || this.$store.state.timezone
    },
    settings () {
      return this.shopSettings(this.shopId)
    },
    time: {
      get () {
        return this.modelValue
      },
      set (newVal) {
        this.$emit('update:modelValue', newVal)
      }
    },
    timeFormat() {
      if (this.format) {
        return this.format
      }
      if (this.settings.timeformat) {
        return this.settings.timeformat
      }
      return 'H:mm'
    },
    datePickerClasses () {
      return {
        menu: '',
        input: 'form-control js-timepicker-input'
      }
    },
  },
  methods: {
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    }
  },
  mounted() {
    this.$emit('update:modelValue', this.modelValue)
  }
}

</script>

<style>
.vuetimepicker .dp--clear-btn {
  top: 50%;
  right: 35px;
}
.dp-action-row {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  padding: 4px 6px;
  width: 100%;
}
</style>